import * as React from 'react';
import { PageHeader } from './PageHeader';
import { PageContainer } from './PageContainer';

type FormPageLayoutProps = {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  backTo?: string | { to: string; params?: Record<string, string> };
  columns?: 1 | 2;
  variant?: 'card' | 'plain';
  cardClassName?: string;
  children: React.ReactNode;
};

export function FormPageLayout({
  title,
  subtitle,
  action,
  backTo,
  columns = 1,
  variant = 'card',
  cardClassName,
  children,
}: FormPageLayoutProps) {
  return (
    <div style={{ viewTransitionName: 'page-body' }}>
      <PageHeader title={title} subtitle={subtitle} action={action} backTo={backTo} />
      <PageContainer size={columns === 1 ? 'form-single' : 'form-two'}>
        {variant === 'card' ? (
          <div
            className={[
              'w-full',
              'sm:bg-surface-1 sm:shadow-sm sm:rounded-lg sm:p-6',
              cardClassName,
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {children}
          </div>
        ) : (
          children
        )}
      </PageContainer>
    </div>
  );
}
